function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("style", {
  type: "text/css"
}, "\r\n\t.st0{fill:#C0C0C0;}\r\n\t.st1{fill:#595959;}\r\n");

var _ref3 =
/*#__PURE__*/
React.createElement("g", null, React.createElement("g", {
  id: "closeSlid_1-2"
}, React.createElement("path", {
  className: "st0",
  d: "M12.5,94.5L12.5,94.5c7.6,3,12.5,10.3,12.5,18.5V0c0,8.1-5,15.4-12.5,18.5l0,0C4.9,21.5,0,28.8,0,36.9V76 C0,84.1,5,91.4,12.5,94.5z"
}), React.createElement("g", null, React.createElement("path", {
  className: "st1",
  d: "M15.3,56.7c0.1-0.1,0.1-0.3,0-0.4L14.4,55l-4.9-6.4c-0.1-0.1-0.2-0.1-0.3-0.1H7.8c-0.3,0-0.5,0.3-0.3,0.6 l5.6,7.2c0.1,0.1,0.1,0.3,0,0.4l-5.6,7.1c-0.2,0.2,0,0.6,0.3,0.6h1.4c0.1,0,0.2-0.1,0.3-0.1l4.9-6.4L15.3,56.7z"
}), React.createElement("path", {
  className: "st1",
  d: "M20.7,56.3l-1-1.3l-4.9-6.4c-0.1-0.1-0.2-0.1-0.3-0.1h-1.4c-0.3,0-0.5,0.3-0.3,0.6l2.8,3.6l2.8,3.6 c0.1,0.1,0.1,0.3,0,0.4l-5.6,7.1c-0.2,0.2,0,0.6,0.3,0.6h1.4c0.1,0,0.2-0.1,0.3-0.1l4.9-6.4c0,0,0,0,0,0l1-1.2 C20.8,56.6,20.8,56.4,20.7,56.3z"
}))));

var SvgCloseSlid = function SvgCloseSlid(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    id: "closeSlid_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 25 112.9",
    style: {
      enableBackground: "new 0 0 25 112.9"
    },
    xmlSpace: "preserve",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgCloseSlid, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/closeSlid.2b424bbd.svg";
export { ForwardRef as ReactComponent };